import React from 'react';
import { notification, Modal } from 'antd/lib';
import { graphql, compose, withApollo } from 'react-apollo';
import Loading from '../../../common/Loading';

import getClasificadoresEstadisticos from '../../../../graphql/querys/clasificadores/getClasificadoresEstadisticos.graphql';
import deleteClasificadorEstadistico from '../../../../graphql/mutations/clasificadores/deleteClasificadorEstadistico.graphql';

import TablaClasificadoresEstadisticos from './TablaClasificadoresEstadisticos';
import { errorService } from '../../../../graphql/utils/utils';

const confirm = Modal.confirm;
@compose(
  graphql(getClasificadoresEstadisticos, {
    options: { fetchPolicy: 'network-only' },
  }),
  graphql(deleteClasificadorEstadistico, {
    name: 'deleteClasificadorEstadistico',
    options: {
      refetchQueries: [{ query: getClasificadoresEstadisticos }],
    },
  })
)
class VerClasificadoresEstadisticos extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      filtro: '',
    };

    this.onDelete = this.onDelete.bind(this);
  }

  onDelete(id) {
    //TODO: Hacer el onDelete.

    let yo = this;
    confirm({
      title: 'Realmente quiere eliminar este clasificador estadistico?',
      content: 'Esta accion no podrá deshacerse',
      onOk() {
        yo.props
          .deleteClasificadorEstadistico({
            variables: { _id: id },
          })
          // eslint-disable-next-line no-unused-vars
          .then(res => {
            notification.success({
              message: 'Clasificador Estadistico eliminado',
              description: 'Se ha eliminado correctamente el clasif',
            });
          })
          .catch(err => {
            console.log(
              'Existio un error a la hora de eliminar el clasificador estadistico'
            );
            console.log(err);
            errorService(err, {
              _id: id,
            });

            Modal.error({
              title: 'Error en la eliminacion del clasificador estadistico',
              content:
                'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
            });
          });
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  render() {
    if (this.state.loading) {
      return <Loading />;
    }

    let listaClasificadoresEstadisticos = this.props.data
      .getClasificadoresEstadisticos;

    if (!listaClasificadoresEstadisticos) {
      listaClasificadoresEstadisticos = [];
    }

    return (
      <div>
        <TablaClasificadoresEstadisticos
          clasificadoresEstadisticos={listaClasificadoresEstadisticos}
          history={this.props.history}
          onDelete={this.onDelete}
        />
      </div>
    );
  }
}

export default withApollo(VerClasificadoresEstadisticos);
